import { OperationRequest } from "../operations/operation-request";
import { Routes } from "../routes";
import { Strategy } from "./abstract-strategy";

export class CustomCheckboxStrat extends Strategy {

    public hasCondition(request: OperationRequest): boolean {
        const hasCustomCheckbox = request.hasCustomCheckbox;
        const acceptedCustomCheckbox = request.acceptedCustomCheckbox;

        if (hasCustomCheckbox && !acceptedCustomCheckbox) {
            return true;
        }
        return false;
    }

    public setStrategy(request?: OperationRequest): void {
        this.pathToGo = Routes.CUSTOM_CHECKBOX;
    }
}
